<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <navbar>
      <template v-slot:navbarname>
        <b-link
            :to="{name:'Stock'}"
            class="btn btn-primary btn-round">Back
        </b-link>
      </template>
    </navbar>
    <!--END Navbar-->

    <b-modal
        centered
        :hide-footer="true"
        size="lg"
        title="Inputs"
        id="modal-1">

      <form-stock
          :logType="'product'"
          :itemId="this.$route.params.productid"></form-stock>

    </b-modal>
    <!--END Inputs-->

    <h2 v-html="product.product_title"></h2>
    <p>inventar: {{ product.product_count | numFormat }}</p>

    <b-card>
      <b-button v-b-modal.modal-1 variant="success">input</b-button>
    </b-card>


    <b-row>
      <b-col cols="12" md="3">
        <b-card style="top: 15px" title="Filter" class="sticky-top">
          <b-form-group
              class="font-weight-bold"
              label="BESTELLNUMMER">
            <b-input v-model="searchInput" placeholder="search..."></b-input>
          </b-form-group>
          <b-form-group
              class="font-weight-bold"
              label="DATE FROM">
            <date-picker
                format="YYYY-MM-DD"
                display-format="YYYY-MM-DD"
                v-model="filters.filterDate.fromDate"
                @change="onSelectFilter"
                locale="en"></date-picker>
          </b-form-group>
          <b-form-group
              class="font-weight-bold"
              label="DATE TO">
            <date-picker
                format="YYYY-MM-DD"
                display-format="YYYY-MM-DD"
                v-model="filters.filterDate.toDate"
                @change="onSelectFilter"
                locale="en"></date-picker>
          </b-form-group>
          <a v-if="filters.filterDate.fromDate != null || filters.filterDate.toDate != null"
             @click.prevent="clearDatesForm"
             href="#" class="text-danger d-block">clear dates</a>
        </b-card>
      </b-col>
      <b-col cols="12" md="9">
        <b-card>
          <b-tabs content-class="mt-3">
            <b-tab title="Inputs">
              <template v-if="logsInput.length > 0">
                <b-button @click="printInput" variant="danger">{{ $t('printTitle') }}</b-button>

                <h4 class="font-weight-bold">Inputs</h4>
                <div id="printInput" class="table-responsive">
                  <log-items :items="logsInput"></log-items>
                </div>
              </template>
            </b-tab>
            <b-tab title="Outputs">
              <template v-if="logsOutput.length > 0">
                <b-button @click="printOutput" variant="danger">{{ $t('printTitle') }}</b-button>

                <div id="printOutput" class="table-responsive">
                  <log-items :items="getOutputItems"></log-items>
                </div>
              </template>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import Navbar from "../Partials/Navbar";
import Http from '../../Services/HttpService/HttpService'
import LogItems from "./Components/LogItems";
import FormStock from "./Components/formStock";
import {EventBus} from "../../Services/Eventbus/event-bus";

export default {
  name: "Details",
  components: {FormStock, LogItems, Navbar},
  data() {
    return {
      page: 1,
      infiniteId: +new Date(),
      product: null,
      logsOutput: [],
      logsInput: [],
      filters: {
        filterDate: {
          fromDate: null,
          toDate: null
        }
      },
      searchInput: null
    }
  },
  computed:{
    getOutputItems() {
      if (this.searchInput === null) {
        return this.logsOutput;
      }

      return this.logsOutput.filter(item => {
        return String(item.orderTrackingNumber).includes(this.searchInput)
      })
    },
  },
  methods: {
    printOutput() {
      this.$htmlToPaper('printOutput');
    },
    printInput() {
      this.$htmlToPaper('printInput');
    },
    clearDatesForm() {
      if (this.filters.filterDate.fromDate != null || this.filters.filterDate.toDate == null) {
        this.filters.filterDate.fromDate = null;
        this.filters.filterDate.toDate = null;
        this.page = 1;
        this.logsInput = [];
        this.logsOutput = [];
        this.infiniteId += 1;
        this.getDetails();
      }
    },
    onSelectFilter() {
      this.page = 1;
      this.logsInput = [];
      this.logsOutput = [];
      this.infiniteId += 1;
      this.getDetails();
    },
    getDetails() {
      if (this.$route.params.productid && this.$route.params.productid > 0) {
        this.$Progress.start();
        Http.post(Http.apiurlV2() + 'stock/show/' + this.$route.params.productid, {
          dateFrom: this.filters.filterDate.fromDate,
          dateTo: this.filters.filterDate.toDate,
        })
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.product = response.data.data.product;
                this.logsInput = response.data.data.logsInput;
                this.logsOutput = response.data.data.logsOutput;
              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
  },
  created() {
    this.getDetails();
  },
  mounted() {
    let myThis = this;
    EventBus.$on('refreshData', function (payload) {
      if (payload === 'yes') {
        myThis.onSelectFilter();
        myThis.$bvModal.hide('modal-1')
      }
    });
  }
}
</script>

<style scoped>

</style>